import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { OnboardingItem } from '@epicuro-next/constants/rule-engine/onboarding-rules';
import { MediaType } from 'graphql-api/gql-api-interfaces';

@Component({
  selector: 'epc-onboarding-item',
  templateUrl: './onboarding-item.component.html',
  styleUrls: ['./onboarding-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OnboardingItemComponent {
  @Input()
  public item: OnboardingItem;

  @Input()
  public isActive = false;

  public MediaType = MediaType;
}
